import script from "./EventsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./EventsSection.vue?vue&type=script&setup=true&lang=js"

import "./EventsSection.vue?vue&type=style&index=0&id=167fbd7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-167fbd7e"]])

export default __exports__